import { BillClaimType } from '../models/Bills.interfaces';
import ApisClient, { ApisClientNoLoader } from '../utils/client/ApisClient';

export const getBills = (monthsRange: string) => {
    return ApisClient.get(`/bills?months=${monthsRange}`);
};

export const getBillDetail = (id?: string) => {
    return ApisClient.get(`/bills/detail?billId=${id}`);
};

export const downloadBill = (billId: string) => {
    return ApisClient.get(`/bills/download?billId=${billId}`, {
        headers: {
            'Content-type': 'application/pdf',
        },
        responseType: 'blob',
    });
};

export const getDebt = () => {
    return ApisClient.get('/bills/debt');
};

export const getDebtDetail = () => {
    return ApisClient.get('/bills/debt/detail');
};

export const getClaimList = (page: number, size: number, startDate: string, endDate: string) => {
    return ApisClient.get(
        `/bills/invoice/claim/follow/orchestration?page=${page}&size=${size}&startDate=${startDate}&endDate=${endDate}`,
    );
};

export const getClaimDetail = (id: string) => {
    return ApisClient.get(`/bills/invoice/claim/follow/detail?economicProblemId=${id}`);
};

export const rehabilitateLines = () => {
    return ApisClient.post('/bills/debt/rehabilitate');
};

export const generateGCOPaymentUrl = () => {
    return ApisClient.post('/bills/debt/payment');
};

export const getInvoiceAdditionalConsumptions = (billId: string, page: number = 1, size: number = 10) => {
    return ApisClient.get(`/bills/invoice/claim/opening/consumption?billId=${billId}&page=${page}&size=${size}`);
};

export const getInvoiceQuota = (billId: string) => {
    return ApisClient.get(`/bills/invoice/claim/opening/quotas?billId=${billId}`);
};

export const getClaimProcedures = (billId: string) => {
    return ApisClient.get(`/bills/invoice/claim/procedures?billId=${billId}`);
};

export const getClaimReclaimable = (billId: string) => {
    return ApisClient.get(`/bills/invoice/claim/procedures/reclaimable?billId=${billId}`);
};

export const getClaimContacts = () => {
    return ApisClient.get(`/bills/invoice/claim/contacts`);
};

export const getClaimMotives = (billId: string, acbrId: string) => {
    return ApisClientNoLoader.get(`/bills/invoice/claim/categorization?billId=${billId}&acbrId=${acbrId}`);
};

export const createClaim = (billClaim: BillClaimType) => {
    return ApisClient.post('/bills/invoice/claim/creation', billClaim);
};

export const getCommunications = (idCustomerProblem: string) => {
    return ApisClient.get(`/communications?idCustomerProblem=${idCustomerProblem}`);
};
